import { render } from "./HelpCenterMenu.vue?vue&type=template&id=f4b0b674&scoped=true"
import script from "./HelpCenterMenu.vue?vue&type=script&lang=js"
export * from "./HelpCenterMenu.vue?vue&type=script&lang=js"

import "./HelpCenterMenu.vue?vue&type=style&index=0&id=f4b0b674&lang=scss"
import "./HelpCenterMenu.vue?vue&type=style&index=1&id=f4b0b674&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b0b674"]])

export default __exports__